import React from "react";
import { ChevronRight } from "lucide-react";
import BackgroundWrapper from "../components/BackgroundWrapper";
import { Link } from "react-router-dom";

export default function StrategicAdvisory() {
  return (
    <BackgroundWrapper>
      <div className="pt-8 pb-20 px-3 sm:px-4 md:px-6 lg:px-8 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/programs"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold text-sm sm:text-base"
          >
            ← Back to Programs
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl shadow-2xl p-6 sm:p-8 md:p-12">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-6 sm:mb-8">
              Strategic Advisory Services
            </h1>

            <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base text-slate-700">
              <li>Strategic assessment of leadership capabilities and traits</li>
              <li>Geo-political risk assessment</li>
              <li>People, systems and processes risks</li>
              <li>Strategy implementation gaps</li>
              <li>Investment risks and opportunities</li>
            </ul>

            <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link
                to="/contact"
                className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:shadow-2xl transition-all text-sm sm:text-base inline-flex items-center justify-center"
              >
                Contact Us <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
              </Link>
              <Link
                to="/programs"
                className="bg-white border-2 border-blue-600 text-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:shadow-xl transition-all text-sm sm:text-base inline-flex items-center justify-center"
              >
                View All Programs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}